module.exports = __webpack_public_path__ + "img/sakuya izayoi.c24a66dd.png";